import tippy from "tippy.js";
import { initIntersectionObserver } from "@plugins";

const simpleTooltips = document.querySelectorAll("[data-tippy-content]");

if (simpleTooltips && simpleTooltips.length) {
    for (const tooltip of simpleTooltips) {
        initIntersectionObserver(tooltip, initSimpleTooltip);
    }
}

function initSimpleTooltip(tooltip) {
    tippy(tooltip, {
        placement: "top",
        arrow: true,
        allowHTML: true,
        theme: "light",
        onShow(instance) {
            instance.setContent(instance.reference.dataset.tippyContent);
        },
        trigger: "mouseenter click",
        hideOnClick: true,
    });
}
